export default __webpack_public_path__ + "static/media/phone-call.48d8b122.svg";